var _desc, _defs, _rect, _circle, _path, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithWriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 480 128",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Sexsocial logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Sexsocial wordmark with dark monogram and coral accent.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "markBg",
    x1: 18,
    y1: 12,
    x2: 108,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4c1420"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#26080f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130306"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "markAccent",
    x1: 34,
    y1: 26,
    x2: 96,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8da4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ff547f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#da2f59"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 108,
    height: 108,
    rx: 30,
    fill: "url(#markBg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 37,
    r: 6,
    fill: "#ff8da4",
    opacity: 0.92
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#markAccent)",
    d: "M66.7 31c11.1 0 19.9 5.2 23.3 13.6l-13.7 3c-2.1-4.4-5.6-6.2-10.8-6.2-5.7 0-9.3 2.3-9.3 6.2 0 4.2 3.4 5.6 13.4 7.3 14.1 2.5 23.3 7.6 23.3 20.7 0 13.9-11.5 22.4-28.2 22.4-15.1 0-25.1-6-29.1-16.8l14.1-2.8c2.7 5.7 7.2 8.2 15.3 8.2 7.6 0 12-2.6 12-6.9 0-4.3-3.3-5.7-13.7-7.6-14.8-2.7-22.9-8.1-22.9-20.6 0-12.9 10.8-20.5 26.3-20.5Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 142,
    y: 83,
    fill: "#fff3f4",
    fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
    fontSize: 74,
    fontWeight: 800,
    letterSpacing: -3
  }, "\n    Sex\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 259,
    y: 83,
    fill: "#ff6a86",
    fontFamily: "Nunito, Segoe UI, Arial, sans-serif",
    fontSize: 74,
    fontWeight: 800,
    letterSpacing: -3
  }, "\n    social\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithWriting);
export default __webpack_public_path__ + "static/media/logo-with-writing.da046c66b806e368bfa5562941c1e145.svg";
export { ForwardRef as ReactComponent };